var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container" },
    [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../assets/img/exyte.png"),
          alt: "exyte Logo",
          width: "820",
          height: "300"
        }
      }),
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.error.statusCode) + "\n  ")
      ]),
      _c("h2", { staticClass: "info" }, [
        _vm._v("\n    " + _vm._s(_vm.error.message) + "\n  ")
      ]),
      _vm.error.statusCode === 404
        ? _c("nuxt-link", { staticClass: "button", attrs: { to: "/" } }, [
            _vm._v("\n    GoTo Calendar View\n  ")
          ])
        : _vm._e(),
      _vm.error.statusCode >= 500
        ? _c("nuxt-link", { staticClass: "button" }, [
            _vm._v("\n    Please Stop Page and Refresh\n  ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5ea9138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ea9138","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d5ea9138","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module chunks = 20